import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./Admin.css";
import { Routes, Route, Navigate } from "react-router-dom";
import Databases from "../pages/Databases/Databases";
import FormsList from "../pages/FormsList/FormsList";
import GenerateForms from "../pages/GenerateForms/GenerateForms";
import Excels from "../pages/Excels/Excels";
import Users from "../pages/Users/Users";
import FormFillPage from "../pages/GenerateForms/FormFillPage";
import FilledFormsList from "../pages/FilledForms/FilledFormsList";
import NotFound from "./404NotFound";
import HistoryLogs from "../pages/HistoryLogs/HistoryLogs";
import UserProfile from "../pages/UserSpace/UserProfile/UserProfile";
import FormsSetsList from "../pages/FormSets/FormsSets";
import Filters from "../pages/Filters/Filters";

export default function Admin() {
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const location = useLocation();

  const toggleSidebar = () => {
    setSidebarVisible((prevState) => !prevState);
  };

  const closeSidebar = () => {
    setSidebarVisible(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        closeSidebar();
      }
    };

    // Close sidebar on initial load for mobile
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean up event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array for initial mount only

  useEffect(() => {
    if (window.innerWidth <= 768) {
      closeSidebar();
    }
  }, [location.pathname]);

  return (
    <div className={`user-layout ${sidebarVisible ? "sidebar-visible" : ""}`}>
      <header>
        <Navbar onSidebarToggle={toggleSidebar} />
      </header>
      <div className="main-content">
        <Sidebar isVisible={sidebarVisible} closeSidebar={closeSidebar} />
        <div className="content-wrapper">
          <div className="content">
            <Routes>
              <Route path="/" element={<Navigate to="/forms-list" />} />
              <Route path="/Databases" element={<Databases />} />
              <Route path="/Forms-List" element={<FormsList />} />
              <Route path="/Forms-Sets-List" element={<FormsSetsList />} />
              <Route path="/Filter-List" element={<Filters />} />
              <Route path="/Filled-Forms-List" element={<FilledFormsList />} />
              <Route path="/Generate-Form" element={<GenerateForms />} />
              <Route path="/Excel" element={<Excels />} />
              <Route path="/Form/:formId" element={<FormFillPage />} />
              <Route path="/Users-List" element={<Users />} />
              <Route path="/History-Logs" element={<HistoryLogs />} />
              <Route path="/Profile" element={<UserProfile />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </div>
      </div>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}
